'use strict';

module.exports = '3.2.2';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 61
// module chunks = 0